import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import TrackSidePanel from './TrackSidePanel.js';
import {
    setShowAutomation
} from 'actions/index.js';

const TracksSidePanel = ({
    style, subSequence, setShowAutomation}) => { 
    let color = style.backgroundColor;
    style = {
        backgroundColor: color //"linear-gradient(0deg, #ffffff61, " + color + "  25%)"
    };

    return (
        <div style={style} className="tracks-side-panel">
          {subSequence.tracks.map(
              track => <TrackSidePanel key={track.id} track={track}/>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setShowAutomation: (show) =>
          dispatch(setShowAutomation(show)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TracksSidePanel);
